import React, { Component, Fragment } from "react";
import {
  Grid,
  withStyles,
  Button,
  Typography,
  Backdrop,
  TextField,
  useMediaQuery,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { useStyles } from "../../components/common/useStyles";
import "../../components/common/Common.css";
import api from "../../components/common/APIValues";
import classNames from "classnames";
import EDWhatLogoIcon from "../../components/images/EdWhat-01-01.png";
import { connect } from "react-redux";
import axios from "axios";
import constant from "../../components/common/Constants";
import routeService from "../../services/Routing";
import { update } from "../../services/ApiService";

const withMediaQuery =
  (...args) =>
  (Component) =>
  (props) => {
    const mediaQuery = useMediaQuery(...args);
    return <Component mediaQuery={mediaQuery} {...props} />;
  };

class EditCommunityDetails extends Component {
  constructor(props) {
    let inputData = props.history.location.inputData;
    if(inputData) {
      super(props);
      this.state = {
        loader: false,
        roles: [],
        permissions: [],
        roleId: 2,
        roleType: "M",
        roleName: "Community Admin",
        roleIdErr: "",
        permissionSelects: [],
        groupName: inputData.title,
        groupDesc: inputData.desc,
        err_msg: "",
        errors: {
          groupName: "",
          groupDesc: "",
        },
        showCreateRole: false,
        editedRoleName: "",
        editedRoleId: 0,
      };
    }
  }

  componentDidMount() {
    let isCommunityAdmin = sessionStorage.getItem('is_community_admin');
    if ((!this.props.userEmail) || (isCommunityAdmin == null) || (isCommunityAdmin !== 'true')) {
      routeService.routePage(this.props, constant.home);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  validateAllInputs = () => {
    if(!this.state.groupName) {
        this.setState({
          errors: {
            groupName: "Title should be non-empty",
          }
        });
        alert("Error: Title should be non-empty");
        return false; 
    }
    if(!this.state.groupDesc) {
      this.setState({
        errors: {
          groupDesc: "Description should be non-empty",
        }
      });
      alert("Error: Description should be non-empty");
      return false; 
    } 
    return true;
  }

  editDetails = (groupId) => {
    if (this.validateAllInputs()) {
      this.setState({ 
        loader: true, 
        errors: {
          groupName: "",
          groupDesc: "",
        } 
      });
      
      let rowData = {
        GroupName: this.state.groupName,
        Env: api.env,
        UpdatedUserId: this.props.userEmail,
      };
      update("CommunitySettings/EditCommunityTitle", rowData, groupId)
      .then((response) => {})
      .catch(function (response) {
        console.log("ERROR: ", response);
      });

      rowData = {
        GroupDesc: this.state.groupDesc,
        Env: api.env,
        UpdatedUserId: this.props.userEmail,
      };
      update("CommunitySettings/EditCommunityDesc", rowData, groupId)
      .then((response) => {})
      .catch(function (response) {
        console.log("ERROR: ", response);
      });

      let pathName = constant.communityHome + groupId;
      let inputData = {
        isJoined: sessionStorage.getItem("isJoinedCommunities"),
      };
      routeService.routePage(this.props, pathName, inputData);
      this.props.history.push(pathName);
      window.location.reload();
    }
  }

  onChangeGroupName = (event) => {
    this.setState({
      groupName: event.target.value,
    });
  };

  onChangeGroupDesc = (event) => {
    this.setState({
      groupDesc: event.target.value,
    });
  };

  goBack = (groupId) => {
    let pathName = constant.communityHome + groupId;
    let inputData = {
      isJoined: sessionStorage.getItem("isJoinedCommunities"),
    };
    routeService.routePage(this.props, pathName, inputData);
  };

  render() {
    const { classes, mediaQuery } = this.props;
    const subTitleWithIcon = classNames(
      classes.subTitle,
      classes.alignTextWithIcon
    );
    const col3 = mediaQuery ? 3 : 6;
    const col4 = mediaQuery ? 4 : 12;
    const col8 = mediaQuery ? 8 : 6;
    const col9 = mediaQuery ? 9 : 12;
    const col1 = mediaQuery ? 1 : 12;
    const col33 = mediaQuery ? 3 : 12;
    const space3 = mediaQuery ? 3 : 2;

    return (
      <Fragment>
        <Backdrop className={classes.backdrop} open={this.state.loader}>
          <img src={EDWhatLogoIcon} height={50} alt="Logo" />
        </Backdrop>

        <Grid
          container
          spacing={0}
          style={{ marginTop: mediaQuery ? "55px" : "90px" }}
        >
          <Grid item xs={12}>
            <Typography className={classes.title}>
              Edit Details
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{ marginTop: "10px" }}>
        <Grid item xs={12}>
            <TextField
              fullWidth
              name="groupName"
              label="Community Name"
              required
              size="small"
              onChange={this.onChangeGroupName}
              noValidate
              value={this.state.groupName}
              variant="outlined"
              style={{ backgroundColor: "#e7e7e7" }}
            />

            {this.state.errors.groupName && this.state.errors.groupName.length > 0 && (
              <span className="error">{this.state.errors.groupName}</span>
            )}
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="groupDesc"
              label="Community Description"
              required
              onChange={this.onChangeGroupDesc}
              noValidate
              value={this.state.groupDesc}
              size="small"
              variant="outlined"
              style={{ backgroundColor: "#e7e7e7" }}
              multiline
              rows={4}
            />

            {this.state.errors.groupDesc && this.state.errors.groupDesc.length > 0 && (
              <span className="error">{this.state.errors.groupDesc}</span>
            )}
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              className={classes.customButtonError}
              onClick={() => this.editDetails(this.props.match.params.groupId)}
              size="small"
            >
              Save
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              className={classes.customButtonError}
              onClick={() => this.goBack(this.props.match.params.groupId)}
              size="small"
            >
              Back
            </Button>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default withRouter(
  withStyles(useStyles)(
    withMediaQuery("(min-width:600px)")(
      connect(mapStateToProps)(EditCommunityDetails)
    )
  )
);
